// Generated by ReScript, PLEASE EDIT WITH CARE


function formatCurrency(price, currency) {
  var value = Math.abs(price).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  switch (currency) {
    case /* AED */0 :
        return "AED " + value;
    case /* BDT */1 :
        return "৳ " + value;
    case /* INR */2 :
        return "₹ " + value;
    
  }
}

function fromString(unit) {
  switch (unit) {
    case "aed" :
        return /* AED */0;
    case "bdt" :
        return /* BDT */1;
    case "rupee" :
        return /* INR */2;
    default:
      throw {
            RE_EXN_ID: "Match_failure",
            _1: [
              "Currency.res",
              15,
              2
            ],
            Error: new Error()
          };
  }
}

export {
  formatCurrency ,
  fromString ,
  
}
/* No side effect */
